import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/forgot-password")({
	component: ForgotPasswordPage,
	ssr: false,
});

function ForgotPasswordPage() {
	return <AuthPage view="FORGOT_PASSWORD" />;
}
